<p-toast key="toastmsg" position="top-right"></p-toast>

<main id="main">
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
            <span> <img src="../../../assets/images/tournament/backBtn.svg" alt="" loading="lazy"> </span>Find A Partner </a>
    </div>
    <div class="topTitle">
        <h2>Find A Partner</h2>
    </div>
    <div class="container mx-auto aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-md-12">
                <div class="partnerDiv">
                    <div class="locationDiv">
                        <div class="locationdivBtn">
                            <button (click)="onDownloadClick('bottom')">
                                <div class="locationicon">
                                    <img src="../../../assets/images/find-partner/location.svg" alt="" loading="lazy">
                                </div>
                                <div class="btnText">
                                    Andheri, Mumbai
                                </div>
                                <div class="arrowIcon">
                                    <img src="../../../assets/images/find-partner/arrowBottom.svg" alt="" loading="lazy">
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="listTime">
                        <button (click)="onDownloadClick('bottom')"> <img
                                src="../../../assets/images/find-partner/plus.svg" alt="" loading="lazy"> <span>List
                                Yourself</span> </button>
                    </div>
                </div>
                <div class="myschedule desktop-version">
                    <button (click)="onDownloadClick('bottom')">
                        <img src="../../../assets/images/find-partner/bellIcon.svg" alt="" loading="lazy">
                        <span>My Schedule and Request status</span>
                        <span class="badgeBtn">{{ (userRequestsCount < 10) ? '0' +userRequestsCount : userRequestsCount
                                }} <img src="../../../assets/images/find-partner/rightarrow.svg" alt="" loading="lazy"></span>
                    </button>
                </div>
                <div class="mainPageTitle desktop-version">
                    <div class="tab-div">
                        <ul class="tabList">
                            <li>
                                <button class="active-btn">
                                    Player
                                </button>
                            </li>
                            <li>
                                <button (click)="onDownloadClick('bottom')">
                                    Coach
                                </button>
                            </li>
                            <li>
                                <button (click)="onDownloadClick('bottom')">
                                    Paid Hits
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- <div class="not-found-section  d-none">
        <div class="col-md-12 not-found-body">
            <img src="assets/img/logo/not-found.gif" alt="">
            <h4>Coming Soon!</h4>
            <p>{{comingSoonMsg}}</p>

        </div>
    </div> -->
    <!-- ======= Product Section ======= -->

    <section class="team academies-details-list">
        <div class="container mx-auto aos-init aos-animate" data-aos="fade-up">
            <div class="row">
                <div class="col-md-3  leftFilters-div">
                    <div class="filter-sidebar">
                        <div class="filter-header">
                            <span class="filter-title">Filters</span>
                            <a class="clear-filter" (click)="clear()">Clear filter</a>
                        </div>
                        <p-accordion [multiple]="true" class="filter-accordion" [activeIndex]="[0,1]">
                            <!-- <p-accordionTab header="TPL Rating">
                                <div class="filterBody">
                                    <div class="filterHeader">
                                        <div class="searchbar">
                                            <form [formGroup]="ratingrangeform">
                                                <div class="price-rangefeild d-flex">
                                                    <ul>
                                                        <li>
                                                            <label>Min. Rating</label>
                                                            <p-inputNumber mode="decimal" [useGrouping]="false"
                                                                formControlName="minvalue" required placeholder="0">
                                                            </p-inputNumber>
                                                            <div *ngIf="f.minvalue?.errors?.min">rating must be greater
                                                                than 1.
                                                            </div>
                                                        </li>
                                                        <li class="toList"> <span class="to">
                                                                to
                                                            </span> </li>
                                                        <li>
                                                            <label>Max. Rating</label>
                                                            <p-inputNumber mode="decimal" [useGrouping]="false"
                                                                formControlName="maxvalue" required placeholder="100">
                                                            </p-inputNumber>
                                                            <div *ngIf="f.maxvalue?.errors?.min">price must be greater
                                                                than 1.
                                                            </div>
                                                        </li>
                                                        <li><button (click)="onClickRating()">Go</button></li>
                                                    </ul>
                                                </div>

                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </p-accordionTab> -->

                            <p-accordionTab header="State">
                                <div class="filterBody">
                                    <div class="filterHeader">
                                        <div class="searchbar">
                                            <input pInputText type="text" placeholder="Search for State"
                                                [(ngModel)]="searchedStateName" (input)="onSearchState($event)"
                                                class="search-input" />
                                            <div class="icon">
                                                <img src="../../../assets/images/tournament/filterSearch.svg" alt="" loading="lazy">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Desktop State Skeleton -->
                                    <div class="filterMainList" *ngIf="isLoadingFilters">
                                        <div *ngFor="let item of [1,2,3,4,5]" class="filterList skeleton-filter-item">
                                            <p-skeleton width="18px" height="18px" borderRadius="4px"></p-skeleton>
                                            <p-skeleton width="70%" height="14px" borderRadius="4px" styleClass="ml-2"></p-skeleton>
                                        </div>
                                    </div>
                                    <div class="filterMainList" *ngIf="!isLoadingFilters">
                                        <div *ngFor="let state of states; trackBy: trackByState" class="filterList">
                                            <p-checkbox [value]="state" [(ngModel)]="selectedState" [binary]="false"
                                                (onChange)="onClickState($event)"></p-checkbox>
                                            <label>{{ state.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </p-accordionTab>
                            <p-accordionTab header="City">
                                <div class="filterBody">
                                    <div class="filterHeader">
                                        <div class="searchbar">
                                            <input pInputText type="text" placeholder="Search for City"
                                                [(ngModel)]="searchedCityName" (input)="onSearchCity($event)"
                                                class="search-input" />
                                            <div class="icon">
                                                <img src="../../../assets/images/tournament/filterSearch.svg" alt="" loading="lazy">
                                            </div>
                                        </div>
                                    </div>


                                    <!-- Desktop City Skeleton -->
                                    <div class="filterMainList" *ngIf="isLoadingFilters">
                                        <div *ngFor="let item of [1,2,3,4,5]" class="filterList skeleton-filter-item">
                                            <p-skeleton width="18px" height="18px" borderRadius="4px"></p-skeleton>
                                            <p-skeleton width="70%" height="14px" borderRadius="4px" styleClass="ml-2"></p-skeleton>
                                        </div>
                                    </div>
                                    <div class="filterMainList" *ngIf="!isLoadingFilters">
                                        <div *ngFor="let city of cities; trackBy: trackByCity" class="filterList">
                                            <p-checkbox [value]="city" [(ngModel)]="selectedCity" [binary]="false"
                                                (onChange)="onClickCity($event)"></p-checkbox>
                                            <label for="selectedAges">{{ city.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </p-accordionTab>

                            <p-accordionTab header="Amenities">
                                <div class="filterBody pt-2">
                                    <div class="filterMainList">
                                        <div *ngFor="let amenities of defaultAmenitiesArray; trackBy: trackByAmenity" class="filterList">
                                            <p-checkbox [binary]="false" [value]="amenities"
                                                [(ngModel)]="selectedAmenities"
                                                (onChange)="onAmenitiesSelect(amenities,$event)"></p-checkbox>
                                            <label for="selectedAges">{{amenities.name}}</label>
                                        </div>
                                    </div>
                                </div>
                            </p-accordionTab>

                            <p-accordionTab header="Date">
                                <div class="filterBody">
                                    <div class="filterMainList">
                                        <div class="filterList">
                                            <label for="selectedAges">Start Date</label>
                                            <p-calendar placeholder="Select Start Date" dateFormat="dd-mm-yy"
                                                appendTo="body" [(ngModel)]="selectedStartDate"
                                                (onSelect)="onSelectStartDate($event)" [showIcon]="true"></p-calendar>
                                        </div>
                                        <div class="filterList">
                                            <label for="selectedAges">End Date</label>
                                            <p-calendar placeholder="Select End Date" dateFormat="dd-mm-yy"
                                                appendTo="body" [(ngModel)]="selectedEndDate"
                                                (onSelect)="onSelectEndDate($event)" [showIcon]="true"></p-calendar>
                                        </div>
                                    </div>
                                </div>
                            </p-accordionTab>

                            <!-- <p-accordionTab header="Month">
                <div class="filterBody">
                  <div class="filterMainList">
                    <div *ngFor="let  month of monthlist" class="filterList">
                      <p-checkbox [value]="month" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{month }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Date">
                <div class="filterBody dateRange">
                  <div class="filterMainList">
                    <div class="d-flex">
                      <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
                        dateFormat="dd/mm/yy" appendTo="body" placeholder="Select Date" (onSelect)="selectDateRange()">
                      </p-calendar>
                      <button pButton label="Clear" title="Clear" class="p-button p-ml-2 p-mb-0" style="color: #fff!important;
                    padding: 6px 0px;
                    width: 30%" (click)="clear()"></button>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Surface">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for surface" [(ngModel)]="ageFilter"
                        class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let court of courtTypeList" class="filterList">
                      <p-checkbox [value]="court" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{ court.label }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab> -->
                        </p-accordion>

                        <!-- <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select State</h6>
                        </div>

                        <div class="sellers d-flex">
                            <p-dropdown inputId="state" [showClear]="true" [options]="states" placeholder="Select"
                                [filter]="true" (onChange)="setState($event)" optionLabel="name"
                                (onClear)="clearState()"></p-dropdown>
                         
                        </div>

                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select City</h6>
                        </div>


                        <div class="sellers d-flex">
                           
                            <p-dropdown inputId="city" [options]="cityList" [filter]="true" [showClear]="true"
                                placeholder="Select City" optionLabel="name" (onChange)="onCitySelect($event)"
                                (onClear)="clearCity()"></p-dropdown>
                         
                        </div>
                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Court</h6>
                        </div>
                        <div class="aminites available-section ">
                            <ul>
                                <li>
                                    <span> <p-checkbox binary="true" (onChange)="setHard($event)"></p-checkbox> </span>
                                    Hard/ Synthetic
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setGrass($event)"></p-checkbox> </span>
                                    Grass
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setClay($event)"></p-checkbox> </span>
                                    Clay
                                </li>
                            </ul>
                        </div>
                    </div> -->
                    </div>
                </div>
                <div class="col-md-9 find-partner-page">
                    <div class="searchTournament">
                        <div class="searchBar">
                            <input type="text" placeholder="Search Players"
                                (input)="onSearchPlayerName($event.target.value)" />
                            <img src="../../../assets/images/tournament/search.svg" alt="" class="icon">
                        </div>
                        <div class="shortBtn">

                            <button class="dateBtn" (click)="onDownloadClick('bottom')">
                                <div class="icon">
                                    <img src="../../../assets/images/find-partner/date.svg" alt="">
                                </div>
                                <div class="title">
                                    Search by Date
                                </div>
                            </button>
                            <button class="dateBtn timeBtn" (click)="onDownloadClick('bottom')">
                                <div class="icon">
                                    <img src="../../../assets/images/find-partner/time.svg" alt="">
                                </div>
                                <div class="title">
                                    Start Time - End Time
                                </div>
                            </button>
                            <button (click)="onDownloadClick('bottom')">
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/sort.svg" alt="">
                                </div>
                                <div class="title">
                                    Sort
                                </div>
                            </button>
                            <div class="shortBtn mobileFilters">
                                <button (click)="showMobileFilter()">
                                    <div class="icon">
                                        <img src="../../../assets/images/tournament/Filter.svg" alt="">
                                    </div>
                                    <div class="title">
                                        FILTER
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="myschedule mobile-version">
                        <button (click)="onDownloadClick('bottom')">
                            <img src="../../../assets/images/find-partner/bellIcon.svg" alt="" class="belicon">
                            <span>My Schedule and Request status</span>
                            <span class="badgeBtn">{{ (userRequestsCount < 10) ? '0' +userRequestsCount :
                                    userRequestsCount }} <img src="../../../assets/images/find-partner/rightarrow.svg"
                                    alt="" class="righticon"></span>
                        </button>
                    </div>
                    <div class="mainPageTitle mobile-version">
                        <div class="tab-div">
                            <ul class="tabList">
                                <li>
                                    <button class="active-btn">
                                        Player
                                    </button>
                                </li>
                                <li>
                                    <button (click)="onDownloadClick('bottom')">
                                        Coach
                                    </button>
                                </li>
                                <li>
                                    <button (click)="onDownloadClick('bottom')">
                                        Paid Hits
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="mobile-version  dateFilterButton">
                        <ul>
                            <li>
                                <button class="dateBtn">
                                    <div class="icon">
                                        <img src="../../../assets/images/find-partner/date.svg" alt="">
                                    </div>
                                    <div class="title">
                                        Search by Date
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button class="dateBtn timeBtn">
                                    <div class="icon">
                                        <img src="../../../assets/images/find-partner/time.svg" alt="">
                                    </div>
                                    <div class="title">
                                        Start Time - End Time
                                    </div>
                                </button>
                            </li>
                        </ul>


                    </div>
                    <div class="col-md-12 mainListDiv">

                        <div class="findList">
                            <ul class="mainListul" *ngIf="!nodata">
                                <!-- <li class="MainList" >
                                    <div class="findP-maindiv">
                                        <div class="fp-header-div">
                                            <div class="leftDiv">
                                                <div class="userImage">
                                                    <img src="../../../assets/images/find-partner/userImage.png" alt="">
                                                </div>
                                                <div class="userDetails">
                                                    <h3>nirmal swamy</h3>
                                                    <h6>TPL RANK <span>450</span> (U12)</h6>
                                                </div>
                                            </div>
                                            <div class="rightDiv">
                                               <div class="videoBtn">
                                                <div class="videobtnhead">
                                                    <div class="icon">
                                                        <img src="../../../assets/images/find-partner/video.svg" alt="">
                                                    </div>
                                                    <div class="title">
                                                        Video
                                                    </div>
                                                </div>
                                                <div class="videobtnbody">
                                                    <div class="icon">
                                                        <img src="../../../assets/images/find-partner/start.svg" alt="">
                                                    </div>
                                                    <div class="title">
                                                        4.5
                                                    </div>
                                                </div>
                                               </div>
                                            </div>
                                        </div>
                                        <div class="fp-body">
                                            <div class="locationsDiv">
                                                <ul>
                                                    <li>
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/locationCity.svg" alt="">
                                                        </div>
                                                        <div class="title">
                                                            Mumbai
                                                        </div>
                                                    </li>
                                                    <li class="lineDiv">
                                                        <div class="line"></div>
                                                    </li>
                                                    <li>
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/maps-location-02.svg" alt="">
                                                        </div>
                                                        <div class="title">
                                                            Andheri
                                                        </div>
                                                    </li>
                                                      <li class="lineDiv">
                                                        <div class="line"></div>
                                                    </li>
                                                    <li>
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/category.svg" alt="">
                                                        </div>
                                                        <div class="title">
                                                            Ball, Court, Racket
                                                        </div>
                                                    </li>
                                                      <li class="lineDiv">
                                                        <div class="line"></div>
                                                    </li>
                                                    <li>
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/club.svg" alt="">
                                                        </div>
                                                        <div class="title">
                                                            Urban Sports Club
                                                        </div>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                        <div class="fp-footer">
                                            <button class="conntectBtn"> 
                                                <div class="icon">
                                                    <img src="../../../assets/images/find-partner/connect.svg" alt="" loading="lazy">
                                                </div>
                                                <div class="title">
                                                    Connect
                                                </div>
                                            </button>
                                            <button class="scheduleBtn">  
                                                <div class="title">
                                                    Schedule a session
                                                </div>
                                            </button>
                                            
                                            
                                        </div>
                                    </div>
                                </li> -->
                                <!-- ===== SKELETON LOADER FOR PARTNER CARDS ===== -->
                                <ng-container *ngIf="isLoadingPartners">
                                    <li class="MainList" *ngFor="let item of skeletonCards">
                                        <div class="findP-maindiv skeleton-card">
                                            <div class="fp-header-div">
                                                <div class="leftDiv">
                                                    <div class="userImage">
                                                        <p-skeleton shape="circle" size="60px"></p-skeleton>
                                                    </div>
                                                    <div class="userDetails" style="margin-left: 15px;">
                                                        <p-skeleton width="150px" height="18px" styleClass="mb-2"></p-skeleton>
                                                        <p-skeleton width="100px" height="14px"></p-skeleton>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="fp-body" style="padding: 15px 0;">
                                                <p-skeleton width="100%" height="20px" styleClass="mb-2"></p-skeleton>
                                                <p-skeleton width="80%" height="20px" styleClass="mb-2"></p-skeleton>
                                            </div>
                                            <div class="fp-footer">
                                                <p-skeleton width="45%" height="40px" borderRadius="8px"></p-skeleton>
                                                <p-skeleton width="45%" height="40px" borderRadius="8px" styleClass="ml-auto"></p-skeleton>
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>

                                <!-- ===== ACTUAL PARTNER LIST ===== -->
                                <ng-container *ngIf="!isLoadingPartners">
                                <li class="MainList" *ngFor="let findPartner of filteredList; trackBy: trackByPartner">
                                    <div class="findP-maindiv">
                                        <div class="fp-header-div">
                                            <div class="leftDiv">
                                                <div class="userImage">
                                                    <img [src]="findPartner?.profilepic" [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                                        [lazyLoad]="findPartner?.profilepic" alt="" loading="lazy">
                                                </div>
                                                <div class="userDetails">
                                                    <h3>{{findPartner?.fullName}}</h3>
                                                    <h6>TPL RANK <span>{{findPartner?.ranking}}</span>
                                                        {{ findPartner?.agegroup ? '('+ findPartner?.agegroup +')' :
                                                        ''}}</h6>
                                                </div>
                                            </div>
                                            <div class="rightDiv">
                                                <div class="videoBtn cursor-pointer"
                                                    *ngIf="findPartner?.isplayerVideoApproved"
                                                    (click)="playVideo(findPartner?.playervideoClip)">
                                                    <div class="videobtnhead">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/video.svg"
                                                                alt="" loading="lazy">
                                                        </div>
                                                        <div class="title">
                                                            Video
                                                        </div>
                                                    </div>
                                                    <div class="videobtnbody">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/start.svg"
                                                                alt="" loading="lazy">
                                                        </div>
                                                        <div class="title">
                                                            {{findPartner?.rating}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="fp-body">
                                            <div class="locationsDiv">
                                                <ul>
                                                    <li>
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/locationCity.svg"
                                                                alt="" loading="lazy">
                                                        </div>
                                                        <div class="title">
                                                            {{findPartner?.cityname}}
                                                            <!-- <span class="infoBtn"> <button><img src="../../../assets/images/find-partner/info.svg" alt="">
                                                            </button></span> -->
                                                        </div>
                                                    </li>
                                                    <li class="lineDiv">
                                                        <div class="line"></div>
                                                    </li>
                                                    <li>
                                                        <div class="icon">
                                                            <img src="../../../assets/images/find-partner/maps-location-02.svg"
                                                                alt="" loading="lazy">
                                                        </div>
                                                        <div class="title">
                                                            {{findPartner?.area}} <span class="infoBtn"> <button
                                                                    (onClick)="op.toggle($event)"><img
                                                                        src="../../../assets/images/find-partner/info.svg"
                                                                        alt=""></button></span>
                                                        </div>
                                                    </li>
                                                    <li class="lineDiv">
                                                        <div class="line"></div>
                                                    </li>
                                                    <li>
                                                        <div class="detailsIconDiv">
                                                            <div class="mainData">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/find-partner/category.svg"
                                                                        alt="" loading="lazy">
                                                                </div>
                                                                <div class="title"
                                                                    [ngStyle]="{ width: (findPartner?.amenities.length > 2) ? '70px' : 'auto' }">
                                                                    {{findPartner?.amenitiesData}}<span class="infoBtn">
                                                                        <button><img
                                                                                src="../../../assets/images/find-partner/info.svg"
                                                                                alt=""></button></span>
                                                                </div>
                                                            </div>
                                                            <div class="icon InfoIcon">
                                                                <i class="pi pi-info-circle"
                                                                    *ngIf="findPartner?.amenities.length > 2"
                                                                    (click)="amenity.toggle($event)"></i>
                                                                <p-overlayPanel #amenity appendTo="body"
                                                                    styleClass="amenity-popup">
                                                                    <ng-template pTemplate>
                                                                        <span
                                                                            style="color: #1C9A2D">{{findPartner?.amenitiesData}}</span>
                                                                    </ng-template>
                                                                </p-overlayPanel>
                                                            </div>
                                                        </div>

                                                        <!-- <div class="icon">
                                                            <img src="../../../assets/images/find-partner/category.svg"
                                                                alt="">
                                                        </div>
                                                        <div class="title"
                                                            [ngStyle]="{ width: (findPartner?.amenities.length > 2) ? '70px' : 'auto' }">
                                                            {{findPartner?.amenitiesData}}
                                                        </div>
                                                        <div class="icon InfoIcon">
                                                            <i class="pi pi-info-circle"
                                                                *ngIf="findPartner?.amenities.length > 2"
                                                                (click)="amenity.toggle($event)"></i>
                                                            <p-overlayPanel #amenity appendTo="body">
                                                                <ng-template pTemplate>
                                                                    <span
                                                                        style="color: #1C9A2D">{{findPartner?.amenitiesData}}</span>
                                                                </ng-template>
                                                            </p-overlayPanel>
                                                        </div> -->
                                                    </li>
                                                    <li class="lineDiv">
                                                        <div class="line"></div>
                                                    </li>
                                                    <li>
                                                        <div class="detailsIconDiv">
                                                            <div class="mainData">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/find-partner/club.svg"
                                                                        alt="" loading="lazy">
                                                                </div>
                                                                <div class="title"
                                                                    [ngStyle]="{ width: (findPartner?.venue.length > 5) ? '70px' : 'auto' }">
                                                                    {{findPartner?.venue}} <span class="infoBtn">
                                                                        <button><img
                                                                                src="../../../assets/images/find-partner/info.svg"
                                                                                alt=""></button></span>
                                                                </div>
                                                            </div>
                                                            <div class="icon InfoIcon">
                                                                <i class="pi pi-info-circle"
                                                                    *ngIf="findPartner?.venue.length > 5"
                                                                    (click)="venue.toggle($event)"></i>
                                                                <p-overlayPanel #venue appendTo="body"
                                                                    styleClass="venue-popup">
                                                                    <ng-template pTemplate>
                                                                        <span
                                                                            style="color: #1C9A2D">{{findPartner?.venue}}</span>
                                                                    </ng-template>
                                                                </p-overlayPanel>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                        <div class="fp-footer">
                                            <button class="conntectBtn" (click)="onDownloadClick('bottom')">
                                                <div class="icon">
                                                    <img src="../../../assets/images/find-partner/connect.svg" alt="" loading="lazy">
                                                </div>
                                                <div class="title">
                                                    Connect
                                                </div>
                                            </button>
                                            <button class="scheduleBtn cursor-pointer"
                                                (click)="onDownloadClick('bottom')">
                                                <div class="title">
                                                    Schedule a session
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                </ng-container>
                            </ul>
                            <div class="contest-pagination p-0">
                                <div class="pagination-div p-0">
                                    <p-paginator *ngIf="!nodata" [rows]="pageLimitFirst" #paginator pageLinkSize="3"
                                        [totalRecords]="totalUserRecords" (onPageChange)="getUserList($event, mode)"
                                        [showPageLinks]="true" [rowsPerPageOptions]="pagination"
                                        [first]="(pageNumberFirst - 1) * pageLimitFirst"></p-paginator>
                                </div>
                            </div>

                            <div *ngIf="nodata" class=" col-md-12 bottom-container tablesections p-0">
                                <div class="header-container box w-100 p-0">
                                    <div class="col-md-12 p-0">
                                        <div class="not-found-section">
                                            <div class="col-md-12 not-found-body">
                                                <img src="assets/img/logo/not-found.gif" alt="">
                                                <h4>Sorry! No Player Found </h4>
                                                <div class="col-md-12">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Product -->
</main><!-- End #main -->

<p-dialog id="login" [closable]="true" [(visible)]="loginRegisterModal" [modal]="true" [style]="{ width: '43.3rem'}"
    [breakpoints]="{ '960px': '75vw', '768px': '100%' }" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        style="margin: 0px!important;    width: 100%; max-width: 100%;">
        <div class="modal-content" style="border: none;">
            <div class="modal-body">
                <section class="login-page-section">
                    <div class="section-title text-center">
                        <p> To enter Tournament, <br> please login or register.
                        </p>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12  l-p-div">
                                <div class="col-md-12 login-page">
                                    <p-tabView id="myTabContent">
                                        <p-tabPanel header="Login with OTP" id="OTP">

                                            <div class="col-md-12 ">
                                                <div *ngIf="!showMobileLoginOtpForm" class="col-md-12 ">
                                                    <form class="login-form" [formGroup]="mobileLoginForm"
                                                        *ngIf="this.mobileLoginForm" (ngSubmit)="onMobilePhoneSubmit()">
                                                        <div class="Phone">
                                                            <label for="name_login">* Mobile:</label>
                                                            <div class="clear"></div>
                                                            <p-inputNumber mode="decimal" [useGrouping]="false"
                                                                formControlName="mobileNumber"
                                                                [ngClass]="{ 'is-invalid': submitted && mobNumberFormValidation.mobileNumber.errors }"
                                                                required placeholder="Enter your mobile number">
                                                            </p-inputNumber>
                                                            <div *ngIf="submitted && mobNumberFormValidation.mobileNumber.errors"
                                                                class="invalid-feedback">
                                                                <div
                                                                    *ngIf="mobNumberFormValidation.mobileNumber.errors.required">
                                                                    Mobile number is required
                                                                </div>
                                                                <div
                                                                    *ngIf="mobNumberFormValidation.mobileNumber.errors">
                                                                    Invalid Mobile Number
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="showMobileFormErrors">
                                                            {{mobileFormsErrors}}
                                                        </div>
                                                        <div id="login-submit">
                                                            <input type="submit" value="Send Verification Code">
                                                        </div>
                                                    </form>
                                                </div>
                                                <div *ngIf="showMobileLoginOtpForm" class="col-md-12 Otp login-page">
                                                    <div
                                                        class="container height-100 d-flex justify-content-center align-items-center">
                                                        <div class="position-relative">
                                                            <div class="card p-2 text-center">
                                                                <div class="col-md-12 otp-header">
                                                                    <div class="row">
                                                                        <div class="col-2">
                                                                            <div class="back-btn">
                                                                                <i class="bi bi-chevron-left"></i>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-10">
                                                                            <h2>Mobile Verification</h2>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6>Please enter the one time password <br> to
                                                                    verify your account
                                                                </h6>
                                                                <div> <span>A code has been sent to </span>
                                                                    <small>{{mobileNumber}}</small>
                                                                </div>
                                                                <div id="otp"
                                                                    class="inputs d-flex flex-row justify-content-center mt-2">
                                                                    <ng-otp-input #ngOtpInput
                                                                        (onInputChange)="onOtpChange($event)"
                                                                        [config]="config" autoFocusOnLoad={false}>
                                                                    </ng-otp-input>
                                                                    <div *ngIf="showOtpErrors">
                                                                        <span>Please enter OTP.</span>
                                                                    </div>
                                                                    <div *ngIf="showOtpLoginErrors">
                                                                        <span>{{otpLoginErrors}}</span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <span
                                                                        *ngIf="!showResendButton">{{displayTime}}</span>
                                                                    <span *ngIf="showResendButton">
                                                                        <div id="">
                                                                            <a (click)="resendOtp()">Resend</a>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="login-submit">
                                                        <input type="submit" (click)="onClickOtpLoginSubmit()"
                                                            value="Submit">
                                                    </div>
                                                </div>
                                            </div>

                                        </p-tabPanel>
                                        <p-tabPanel header="Login with Password" id="loginuser">
                                            <div class="col-md-12">
                                                <form class="login-form" [formGroup]="loginForm" *ngIf="this.loginForm"
                                                    (ngSubmit)="onSubmit()">
                                                    <div class="name">
                                                        <label for="name_login">Email:</label>
                                                        <div class="clear"></div>
                                                        <input type="email" id="name_login" formControlName="email"
                                                            placeholder="Email Address*"
                                                            [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.email.errors }"
                                                            required>
                                                        <div *ngIf="loginFormSubmitted && loginf.email.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="loginf.email.errors.required">Email
                                                                is required</div>
                                                            <div *ngIf="loginf.email.errors.email">Enter
                                                                valid email address
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pwd">
                                                        <label for="password_login">Password:</label>
                                                        <div class="clear"></div>
                                                        <p-password [toggleMask]="true" id="password_login"
                                                            formControlName="password" [appendTo]="false"
                                                            placeholder="Password*"
                                                            class="form-control login-password-form"
                                                            [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.password.errors }"
                                                            autocomplete="on" required></p-password>
                                                        <div *ngIf="loginFormSubmitted && loginf.password.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="loginf.password.errors.required">
                                                                Password is required
                                                            </div>
                                                            <div *ngIf="loginf.password.errors.minlength">
                                                                Password must be at
                                                                least 6
                                                                characters
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 input-form">
                                                    </div>
                                                    <div class="col-md-12 input-form">
                                                        <div *ngIf="isLoginFailed" class="alert alert-danger"
                                                            role="alert">
                                                            {{errorMessage}}
                                                        </div>
                                                    </div>
                                                    <div class="forgot-p">
                                                        <label for="flexCheckDefault">
                                                            <div class="forms">
                                                                <input class="form-check-input" type="checkbox" value=""
                                                                    id="flexCheckDefault">
                                                                <span>Remember me</span>
                                                            </div>
                                                        </label>
                                                        <label for="forgot-password_login"> <a
                                                                (click)="onClickForgotPassword()">
                                                                Forgot
                                                                Password</a></label>
                                                    </div>
                                                    <div id="login-submit" class="otp-submit">
                                                        <input pButton type="submit" value="Login">
                                                    </div>
                                                    <div class="ragister-btn"> New User? <a
                                                            routerLink="/sign-up">Register Now.</a>
                                                    </div>
                                                </form>
                                            </div>
                                        </p-tabPanel>

                                    </p-tabView>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>



</p-dialog>
<p-dialog [closable]="true" [(visible)]="showForgotPasswordForm" [modal]="true" [style]="{width: '38vw'}"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <section *ngIf="showForgotPasswordForm" class="login-page-section">
        <div class="section-title text-center">
            <p> Forgot Password
            </p>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 ">
                    <div class="col-md-12 login-page">
                        <form [formGroup]="forgotPassForm">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="style-form-group">
                                        <input type="tel" formControlName="email" class="form-control form-input"
                                            placeholder="Your Email *"
                                            [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                        <div *ngIf="submitted && forgotPassValidation.email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="forgotPassValidation.email.errors.required">Email is
                                                required</div>
                                            <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                                                valid
                                                email address</div>
                                        </div>
                                        <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                                        </div>
                                        <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="button pt-2 pt-lg-3">
                                <button class="forgot-pass-submit"
                                    (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                                <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</p-dialog>
<p-dialog [contentStyle]="{'overflow': 'visible'}" [closable]="true" [autoZIndex]="true" [blockScroll]="true"
    [(visible)]="showScheduleMatchDialog" (onHide)="onScheduleMatchDialogClose()" [modal]="true"
    header="Schedule a Session" [style]="{width: '500px'}" [breakpoints]="{'960px': '60vw', '640px': '100vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false" id="Calender">
    <div class="calendar w-100">
        <full-calendar [options]="options" class="w-100"></full-calendar>
    </div>
    <div class="available-section col-md-12">
        <h6>Available Time Slot</h6>
        <form [formGroup]="scheduleForm" *ngIf="this.scheduleForm">
            <div class="timeslote-body">
                <div *ngFor="let schedule of scheduleList" class="check-list">
                    <p-checkbox binary="true" formControlName="{{schedule.id}}" [value]="schedule.status"
                        (onChange)="onScheduleCheckboxSelect($event,schedule.id,schedule.userName,schedule.startDate,schedule.charges,schedule.sheduleDate)"
                        inputId="{{schedule.id}}"></p-checkbox>
                    <label for="{{schedule.id}}"> {{schedule.startDate}} - {{schedule.endDate}} | Session Charged:
                        {{schedule.charges|currency:"INR"}}</label>
                    <span *ngIf="schedule.description" class="i-btn"> <a style="cursor: pointer;"
                            (click)="toggleDescription(schedule.id)"> <i
                                class='bx bx-error-circle description-icon'></i></a></span>
                    <!-- class="ui-tooltip-text" [pTooltip]="schedule.description" tooltipPosition="top" -->
                    <div class="description-box" *ngIf="isSelectedSchedule(schedule.id)">
                        <span>
                            <p class="find-partner-description"><span>Description: </span> {{schedule.description}}</p>
                        </span>
                    </div>
                </div>
                <div class="check-list">
                    <p-checkbox binary="true" formControlName="termsAndConditions" [value]="termsAndConditions"
                        (onChange)="onTermsAndConditionsSelect($event)" inputId="termsAndConditions"></p-checkbox>
                    <label class="form-check-label" for="defaultCheck1">
                        I accept the <a class="termsConditionText" href="/termsandcondition#FindPartner">Terms and
                            Conditions</a>
                    </label>
                </div>

                <div *ngIf="scheduleList.length != 0 && (selectedSchedule.length < 1 || !termsAndConditionsCheck)">
                    <span>To Book schedule, Select time slot & accept the terms and conditions.</span>
                </div>


                <div class="check-list" style="margin-bottom: 1.5rem;">

                    <span *ngIf="scheduleList.length == 0" style="font-size: 14px;     display: flex;
                    align-items: center;"> <span class="mr-2"> <i class="pi pi-clock"
                                style="font-size:16px"></i></span> Time slot not available for
                        {{selectedDate | date:"dd-MM-yyyy"}} date.</span>
                </div>
            </div>
            <!-- <div class="modal-footer">
                <button *ngIf="scheduleList.length > 0" type="submit" pButton>Book Slot</button>
            </div> -->
        </form>
    </div>
    <ng-template pTemplate="footer">
        <form [formGroup]="scheduleForm" (ngSubmit)="onScheduleSubmit()">

            <div class="modal-footer">
                <!-- <button *ngIf="scheduleList.length > 0" type="submit" pButton>Book Slot</button> -->
                <button class="disableBtn" type="submit" *ngIf="selectedSchedule.length > 0 && termsAndConditionsCheck"
                    (click)="showWalletDialog()">Book a
                    Slot </button>

            </div>
        </form>
    </ng-template>
</p-dialog>


<div class="modal fade" id="mobile-filter-popup" tabindex="-1" aria-labelledby="mobile-filter-popupLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <div class="col-md-12 main-title">
                    <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="left-side-section">
                    <div class="">

                        <div class="fliter-div">
                            <div class="col-md-12">
                                <h6>Select Player Type</h6>
                            </div>
                            <div class="sellers d-flex category">
                                <!-- <p-multiSelect inputId="multiselect" display="chip" [options]="userCategories"
                                    optionLabel="name" optionValue="slug" [filter]="false"
                                    (onChange)="onClickUserCategory($event)"
                                    class="ng-invalid ng-dirty"></p-multiSelect> -->
                                <form [formGroup]="partnerform">
                                    <p-dropdown inputId="category" [options]="userCategories"
                                        (onClear)="onClickUserCategory($event)" placeholder="Select" [filter]="true"
                                        (onChange)="onClickUserCategory($event)" optionLabel="user_role_description"
                                        appendTo="body" [showClear]="true" formControlName="playerValue">
                                        <!-- <ng-template pTemplate="selectedItem">
                                        <div class="country-item country-item-value" *ngIf="selectedCategories">
                                            <div>{{selectedCategories}}</div>
                                        </div>
                                    </ng-template> -->
                                    </p-dropdown>
                                </form>
                                <!-- <select name="type" id="type" class=" mb-3 w-100 border p-2 focus:outline-none">
                                    <option value="" selected="">Select Player Type</option>
                                    <option value="blue">Pro-Player</option>
                                    <option value="red">Coach</option>
                                    <option value="green">Amateur</option>
                                </select> -->
                            </div>
                        </div>
                    </div>

                    <div class="price-range fliter-div pt-2">
                        <div class="col-md-12">
                            <h6>Price Range</h6>
                        </div>
                        <form [formGroup]="pricerangeform">

                            <div class="price-rangefeild d-flex">
                                <ul>
                                    <li>
                                        <span class="currency">₹</span>
                                        <p-inputNumber mode="decimal" [useGrouping]="false" formControlName="minvalue"
                                            required placeholder="Min Price">
                                        </p-inputNumber>
                                        <div *ngIf="f.minvalue?.errors?.min">price must be greater than 1.
                                        </div>

                                        <!-- <input type="number" class="form-control" formControlName="minvalue"
                                            placeholder="Min Price">
                                            <div *ngIf="partnerform.minvalue.min"></div> -->
                                    </li>
                                    <li>-</li>
                                    <li>
                                        <span class="currency">₹</span>
                                        <p-inputNumber mode="decimal" [useGrouping]="false" formControlName="maxvalue"
                                            required placeholder="Max Price">
                                        </p-inputNumber>
                                        <div *ngIf="f.maxvalue?.errors?.min">price must be greater than 1.
                                        </div>
                                    </li>
                                    <li><button (click)="onClickpricerange()">Go</button></li>
                                </ul>
                            </div>

                        </form>
                    </div>
                    <div class="price-range fliter-div pt-2">
                        <div class="col-md-12">
                            <h6>TPL Rating</h6>
                        </div>
                        <form [formGroup]="pricerangeform">

                            <div class="price-rangefeild d-flex">
                                <ul>
                                    <li>

                                        <p-inputNumber mode="decimal" [useGrouping]="false" formControlName="minvalue"
                                            required placeholder="Min Price">
                                        </p-inputNumber>
                                        <div *ngIf="f.minvalue?.errors?.min">price must be greater than 1.
                                        </div>

                                        <!-- <input type="number" class="form-control" formControlName="minvalue"
                                            placeholder="Min Price">
                                            <div *ngIf="partnerform.minvalue.min"></div> -->
                                    </li>
                                    <li>-</li>
                                    <li>

                                        <p-inputNumber mode="decimal" [useGrouping]="false" formControlName="maxvalue"
                                            required placeholder="Max Price">
                                        </p-inputNumber>
                                        <div *ngIf="f.maxvalue?.errors?.min">price must be greater than 1.
                                        </div>
                                    </li>
                                    <li><button (click)="onClickpricerange()">Go</button></li>
                                </ul>
                            </div>

                        </form>
                    </div>
                    <div class="fliter-div">
                        <div class="col-md-12">
                            <h6>Select State</h6>
                        </div>
                        <div class="sellers d-flex">
                            <p-dropdown inputId="state" (onClear)="onClickState($event)" [showClear]="true"
                                appendTo="body" [options]="states" placeholder="Select" [filter]="true"
                                (onChange)="onClickState($event)" optionLabel="name"></p-dropdown>
                            <!-- <select name="type" id="type" class=" mb-3 w-100 border p-2 focus:outline-none">
                                <option value="" selected="">Select State</option>
                                <option value="red">Andhra Pradesh</option>
                                <option value="blue">Arunachal Pradesh</option>
                                <option value="green">Assam</option>
                                <option value="green">Goa</option>
                                <option value="green">Gujarat</option>
                                <option value="green">Haryana</option>
                                <option value="green">Kerala</option>
                                <option value="green">Maharashtra</option>
                                <option value="green">Manipur</option>
                                <option value="green">Meghalaya</option>
                                <option value="green">Rajasthan</option>
                            </select> -->
                        </div>
                    </div>
                    <div class="fliter-div">
                        <div class="col-md-12">
                            <h6>Select City</h6>
                        </div>
                        <div class="sellers d-flex">
                            <!-- //(onLazyLoad)="getCity($event)" -->
                            <p-dropdown inputId="city" [showClear]="true" [options]="cities" placeholder="Select"
                                appendTo="body" [filter]="true" (onClear)="onClickCity($event)"
                                (onChange)="onClickCity($event)" optionLabel="name"></p-dropdown>
                            <!-- <select name="type" id="type" class="mb-3  border p-2 focus:outline-none w-100 ">
                                <option selected="">Select City</option>
                                <option>Mumbai</option>
                                <option value="1">Pune</option>
                                <option value="2">Vadodara</option>
                                <option value="3">Hyderabad</option>
                                <option value="3">Delhi</option>
                                <option value="3">Bengaluru</option>
                                <option value="3">Chennai</option>
                            </select> -->
                        </div>
                    </div>
                    <div class="fliter-div">
                        <div class="col-md-12">
                            <h6>Amenities</h6>
                        </div>
                        <div class="aminites available-section ">
                            <ul>
                                <li *ngFor="let amenities of defaultAmenitiesArray">
                                    <span>
                                        <p-checkbox binary="true"
                                            (onChange)="onAmenitiesSelect(amenities,$event)"></p-checkbox>
                                    </span> {{amenities.name}}
                                </li>
                                <!-- <li>
                            <span><input type="checkbox"> </span> Gear
                            </li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="fliter-div date">
                        <div class="col-md-12">
                            <div class="filter-lable-title">
                                <h6>Select Date </h6> <button pButton label="Clear Filter" title="Clear Filter"
                                    class="p-button p-ml-2 p-mb-2" (click)=" clear() "></button>
                            </div>

                        </div>
                        <p-calendar placeholder="Select Date" dateFormat="dd-mm-yy" appendTo="body"
                            [(ngModel)]="rangeDates" (onSelect)="onSelectStartDate($event)"
                            [showIcon]="true"></p-calendar>
                        <!-- <button pButton label="Clear" title="Clear" class="p-button p-ml-2 p-mb-2" style="color: #fff!important;
                        padding: 6px 0px;
                        width: 30%" (click)=" clear('date') "></button> -->
                        <div class="aminites available-section ">
                            <ul class="date-list-filter">
                                <span>
                                    <p-checkbox binary="true"
                                        (onChange)="onClickTodayRecurringSelect(recurringArray[0], $event)"></p-checkbox>
                                    {{recurringArray[0].name}}
                                </span>
                                <span>
                                    <p-checkbox binary="true"
                                        (onChange)="onTomorrowRecurringSelect(recurringArray[1], $event)"></p-checkbox>
                                    {{recurringArray[1].name}}
                                </span>
                                <!-- <li *ngFor="let recurring of recurringArray">
                                    <div *ngIf="recurring.slug !='every_week' && recurring.slug != 'every_month'"
                                        class="dates-div">
                                        <span>
                                            <p-checkbox binary="true"
                                                (onChange)="onRecurringSelect(recurring, $event)"></p-checkbox>
                                            {{recurring.name}}
                                        </span>

                                    </div>
                                </li> -->
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer filter-button">

                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">Apply</button>
            </div>
        </div>
    </div>
</div>


<p-dialog id="Pay" [(visible)]="Walletdialog" header=" " [breakpoints]="{ '960px': 'calc(100% - 30px)' }"
    [style]="{ width: '500px' }" [modal]="Walletdialog" [draggable]="false" [resizable]="false"
    (onHide)="onScheduleMatchDialogClose()">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        style="margin: 0px!important;    width: 100%; max-width: 100%;">

        <div class="modal-content">

            <div class="modal-body pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form action="#">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 pp-none-mobile">
                                            <div *ngIf="Walletdialog" class="modal-content" style="border:none;">
                                                <div class="wallet-screen" style="display: block;">
                                                    <div class="total-amount">
                                                        <div class="wallet-icons">
                                                            <div class="icon">
                                                                <i class='bx bx-wallet-alt'></i>
                                                            </div>
                                                            <h1>Session Fees</h1>
                                                            <h1> <span
                                                                    style=" font-size: 16px; margin-right: 2px;">₹</span>{{
                                                                totalEntryFee() }} </h1>
                                                            <div class="table-selectform w-100">
                                                                <table class="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Name</th>
                                                                            <th scope="col">Date</th>
                                                                            <th scope="col">Time</th>
                                                                            <th scope="col">Fees</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            *ngFor="let sheduledata of selectedScheduleData">
                                                                            <td>{{sheduledata.userName}} </td>
                                                                            <td>{{sheduledata.scheduleDate | date:
                                                                                'dd/MM/yyy'}}</td>
                                                                            <td>{{sheduledata.startTime}}</td>
                                                                            <td>₹ {{sheduledata.charges}}</td>
                                                                        </tr>

                                                                    </tbody>
                                                                    <tfoot>
                                                                        <tr>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td> <strong>Total</strong></td>
                                                                            <td><strong>₹ {{ totalEntryFee() }}</strong>
                                                                            </td>
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 add-buttons">
                                                            <div class="heading d-flex justify-content-between">
                                                                <h2>Select Payment</h2>
                                                                <h2>
                                                                    <span class="mobile-none-d"
                                                                        style="font-family:'Krona One'; ">Available</span>
                                                                    Balance
                                                                </h2>

                                                            </div>

                                                            <ul>
                                                                <li class="tpl-cash"> <label class="form-check-label"
                                                                        for="flexRadioDefault1">
                                                                        <input class="form-check-input" type="radio"
                                                                            name="flexRadioDefault"
                                                                            id="flexRadioDefault1"
                                                                            (click)="onRadioClick()" checked>
                                                                        <!-- <input class="form-check-input" type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault1"> -->
                                                                        <div class="buttons">
                                                                            TPL Wallet
                                                                            <span class="Balance">
                                                                                ₹{{walletBalance}} <span class="addmore"
                                                                                    (click)="Addcashdialog()"> Load
                                                                                    Wallet
                                                                                </span></span>
                                                                        </div>
                                                                    </label>
                                                                </li>

                                                            </ul>
                                                            <!-- <p class="cash-ms"
                                                            [style.display]="displayCashMs ? 'block' : 'none'"
                                                            *ngIf="!isRegisterButtonEnabled() ">
                                                            After Transaction Your Balance will Be ₹{{ walletBalance -
                                                            totalEntryFee()}}
                                                        </p> -->
                                                            <div class="thamkyou-notes" *ngIf="thankYouMsg">
                                                                <p-messages severity="success">
                                                                    <ng-template pTemplate>
                                                                        <img src="../../../../assets/img/Tournament/checked.png"
                                                                            width="32" />
                                                                        <div class="note-div-section w-100 ml-2">
                                                                            <div class="ml-1 w-100">Thank You!</div>
                                                                            <div class="note">
                                                                                Your wallet has been successfully
                                                                                credited
                                                                                with the amount.
                                                                            </div>
                                                                        </div>
                                                                    </ng-template>
                                                                </p-messages>
                                                            </div>
                                                            <p class="cash-ms"
                                                                *ngIf="displayCashMs && !showAddMoneyMessage">
                                                                After Transaction Your Balance will Be ₹{{ walletBalance
                                                                -
                                                                totalEntryFee()}}
                                                            </p>
                                                            <!-- <p class="cash-ms" [ngClass]="{ 'disabled-message': !isRegisterButtonEnabled()}">
                                                            <span *ngIf="displayCashMs">After Transaction Your Balance Will Be ₹{{
                                                              totalleftCash}}</span>
                                                          </p> -->
                                                            <p style="color: red;" *ngIf="showAddMoneyMessage">Please
                                                                add money to your wallet</p>

                                                            <!-- <a id="Entered-btn" class="button button-primary" (click)="thankyouModal()"
                                                        [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a> -->

                                                            <div class="col-md-12 text-center">
                                                                <!-- <button class="button button-primary" [disabled]="isRegisterButtonEnabled()" (click)="onScheduleSubmitRegister()">Register</button> -->
                                                                <a id="Entered-btn" class="button button-primary"
                                                                    [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"
                                                                    (click)="onScheduleSubmitRegister()"> Book a Slot
                                                                </a>
                                                            </div>

                                                            <!-- <div class="col-md-12 text-center">
                                                            <a  class="button button-primary" (click)="onScheduleSubmitRegister()"
                                                            [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a>
                                                            < <p class="cash-ms" [ngClass]="{ 'disabled-message': !isRegisterButtonEnabled() }"> 
                                                                Register
                                                              </p> -->
                                                            <!-- <button  onclick=onScheduleSubmitRegister  id="Entered-btn" class="button button-primary">
                                                                Register
                                                            </button> -->
                                                            <!-- </div>  -->

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</p-dialog>
<p-dialog id="add-cash" [closable]="true" [(visible)]="Addcashmodal"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '500px' }" [modal]="true"
    [draggable]="false" [resizable]="false" header="Add Cash" (onHide)="cashclose()">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        style="margin: 0px!important; width: 100%; max-width: 100%;">
        <div class="modal-content">

            <div class="modal-body add-cash pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form [formGroup]="addCashForm" *ngIf="this.addCashForm">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 ">

                                            <div class="wallet-screen" style="display: block;">
                                                <div class="total-amount">
                                                    <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <h1>Enter Amount</h1>
                                                    </div>
                                                    <div class="col-md-12 add-buttons">
                                                        <div class="add-money-form col-md-12">
                                                            <input type="number" id="myInput2" placeholder="₹ 0"
                                                                formControlName="amount" [(ngModel)]="addedAmount"
                                                                [ngClass]="{ 'is-invalid': submitted && f.amount.errors }">
                                                            <div *ngIf="submitted && f.amount.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="f.amount.errors.required">Amount is required
                                                                </div>
                                                                <div
                                                                    *ngIf="!f.amount.errors.required && f.amount.errors">
                                                                    Only Numbers allowed</div>
                                                            </div>
                                                            <div class="p-field p-col-12 msg-div">
                                                                <p-messages severity="info">
                                                                    <ng-template pTemplate>
                                                                        <i class="pi pi-info-circle"></i>
                                                                        <div class="ml-2">Please Note: For iPhone users
                                                                            - To make a payment using Gpay, select
                                                                            "Others" option in the UPI menu and manually
                                                                            enter your UPI ID.</div>
                                                                    </ng-template>
                                                                </p-messages>

                                                            </div>

                                                        </div>
                                                        <!-- <div class="p-field p-col-12 msg-div">
                                                            <p-messages severity="info">
                                                                <ng-template pTemplate>
                                                                   <i class="pi pi-info-circle"></i>
                                                                   <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay, select "Others" option in the UPI menu and manually enter your UPI ID.</div>
                                                                </ng-template>
                                                            </p-messages>
                                                           
                                                        </div> -->
                                                        <div id="text-out">{{outputText}}</div>
                                                        <div class="col-md-12 text-center">
                                                            <a href="#" (click)="onCashSubmit($event)"
                                                                class="button button-primary">
                                                                Add to Wallet
                                                            </a>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thanYoumodal"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '34.8rem' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <!---test-->
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Partner Schedule Entry</h5>
                <div class="headings col-md-12">
                    <p class="note">You have successfully Booked</p>
                </div>
                <div class="countdown-container">
                    <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
                    <div class="countdown-text">{{ countdown }}</div>
                    <br>

                </div>
                <div class="timer-alert">
                    Please wait 10 seconds.
                </div>
                <p class="note text-center">
                    Your payment will be automatically debited from Wallet.
                </p>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog id="completeProfile" [(visible)]="welcomeLogin"
    [breakpoints]="{ '960px': '500px', '768px': 'calc(100% - 60px)', '389px': 'calc(100% - 30px)' }"
    [style]="{ width: '500px' }" [modal]="true" [draggable]="false" [resizable]="false"
    (onHide)="hideWelcomeLoginDialog()">
    <div class="Welcome-popup">
        <h4>
            Complete Your Profile!
        </h4>
        <p>You are required to complete your profile to proceed further</p>
        <hr class="line-div">
        <div class="actionButton">
            <div class="completeProfile_Button">
                <button type="button" [routerLink]="(!isContestVerified) ? '/profile-edit2' : '/dob-verification'"
                    [queryParams]="(!isContestVerified) ? { page : 'find-partner'} : { isAbout18: isAbove18Check, page : 'find-partner'}">Complete
                    Profile</button>
            </div>
            <div class="skip_Button">
                <button (click)="hideWelcomeLoginDialog()">Cancel</button>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog id="showVideo" [(visible)]="showVideo" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
    [style]="{ width: '34.8rem' }" [modal]="true" [draggable]="false" header="Player Video" [resizable]="false"
    (onHide)="onshowVideoClose()">
    <!---test-->
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">

                <div class="headings col-md-12 modal-video-section">
                    <video width="100%" height="100%" [src]="selectedVideo" controls="" loop="">
                        Your browser does not support HTML5 video.
                    </video>
                </div>
            </div>
        </div>
    </div>
</p-dialog>


<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>


<p-dialog id="mobileFilter" [(visible)]="mobilFilter" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
    [style]="{ width: '400px' }" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
    <ng-template pTemplate="header">
        <div class="filterHeader">
            <div class="title">
                <h6>Filters</h6>
            </div>
            <div class="close">
                <button pButton type="button" icon="pi pi-times" (click)="mobilFilter = false"></button>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="card filterTab">

            <p-tabView [(activeIndex)]="activeIndex">
                <p-tabPanel header="TPL Rating">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterHeader">
                            <div class="searchbar">
                                <form [formGroup]="ratingrangeform">
                                    <div class="price-rangefeild d-flex">
                                        <ul>
                                            <li>
                                                <label>Min. Rating</label>
                                                <p-inputNumber mode="decimal" [useGrouping]="false"
                                                    formControlName="minvalue" required placeholder="0">
                                                </p-inputNumber>
                                                <div *ngIf="f.minvalue?.errors?.min">rating must be greater than 1.
                                                </div>

                                                <!-- <input type="number" class="form-control" formControlName="minvalue"
                                            placeholder="Min Price">
                                            <div *ngIf="partnerform.minvalue.min"></div> -->
                                            </li>
                                            <li class="toList"> <span class="to">
                                                    to
                                                </span> </li>
                                            <li>
                                                <label>Max. Rating</label>
                                                <p-inputNumber mode="decimal" [useGrouping]="false"
                                                    formControlName="maxvalue" required placeholder="100">
                                                </p-inputNumber>
                                                <div *ngIf="f.maxvalue?.errors?.min">price must be greater
                                                    than 1.
                                                </div>
                                            </li>
                                            <li><button (click)="onClickRating()">Go</button></li>
                                        </ul>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="TPL Ranking">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterHeader">
                            <div class="searchbar">
                                <form [formGroup]="ratingrangeform">
                                    <div class="price-rangefeild d-flex">
                                        <ul>
                                            <li>
                                                <label>Min. Ranking</label>
                                                <p-inputNumber mode="decimal" [useGrouping]="false"
                                                    formControlName="minvalue" required placeholder="0">
                                                </p-inputNumber>
                                                <div *ngIf="f.minvalue?.errors?.min">rating must be greater than 1.
                                                </div>
                                            </li>
                                            <li class="toList"> <span class="to">
                                                    to
                                                </span> </li>
                                            <li>
                                                <label>Max. Ranking</label>
                                                <p-inputNumber mode="decimal" [useGrouping]="false"
                                                    formControlName="maxvalue" required placeholder="100">
                                                </p-inputNumber>
                                                <div *ngIf="f.maxvalue?.errors?.min">price must be greater
                                                    than 1.
                                                </div>
                                            </li>
                                            <!-- <li><button (click)="onClickRating()">Go</button></li> -->
                                        </ul>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="State">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for State"
                                    [(ngModel)]="searchedStateName" (input)="onSearchState($event)"
                                    class="search-input" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <!-- Skeleton for state filter -->
                        <div class="filterMainList" *ngIf="isLoadingFilters">
                            <div *ngFor="let item of [1,2,3,4,5]" class="filterList skeleton-filter-item">
                                <p-skeleton width="18px" height="18px" borderRadius="4px"></p-skeleton>
                                <p-skeleton width="70%" height="14px" borderRadius="4px" styleClass="ml-2"></p-skeleton>
                            </div>
                        </div>
                        <div class="filterMainList" *ngIf="!isLoadingFilters">
                            <div *ngFor="let state of states; trackBy: trackByState" class="filterList">
                                <p-checkbox [value]="state" [(ngModel)]="selectedState" [binary]="false"
                                    (onChange)="onClickState($event)"></p-checkbox>
                                <label>{{ state.name }}</label>
                            </div>
                        </div>

                    </div>
                </p-tabPanel>
                <p-tabPanel header="City">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for City"
                                    [(ngModel)]="searchedCityName" (input)="onSearchCity($event)"
                                    class="search-input" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <!-- Skeleton for city filter -->
                        <div class="filterMainList" *ngIf="isLoadingFilters">
                            <div *ngFor="let item of [1,2,3,4,5]" class="filterList skeleton-filter-item">
                                <p-skeleton width="18px" height="18px" borderRadius="4px"></p-skeleton>
                                <p-skeleton width="70%" height="14px" borderRadius="4px" styleClass="ml-2"></p-skeleton>
                            </div>
                        </div>
                        <div class="filterMainList" *ngIf="!isLoadingFilters">
                            <div *ngFor="let city of cities; trackBy: trackByCity" class="filterList">
                                <p-checkbox [value]="city" [(ngModel)]="selectedCity" [binary]="false"
                                    (onChange)="onClickCity($event)"></p-checkbox>
                                <label for="selectedAges">{{ city.name }}</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Amenities">
                    <div class="filterBody">

                        <div class="filterMainList mt-0">
                            <div *ngFor="let amenities of defaultAmenitiesArray; trackBy: trackByAmenity" class="filterList">
                                <p-checkbox [binary]="false" [value]="amenities" [(ngModel)]="selectedAmenities"
                                    (onChange)="onAmenitiesSelect(amenities,$event)"></p-checkbox>
                                <label for="selectedAges">{{amenities.name}}</label>
                            </div>
                        </div>

                    </div>
                </p-tabPanel>
                <p-tabPanel header="Date">
                    <div class="filterBody">
                        <div class="filterMainList mt-0 dateListFilter">
                            <div class="filterList">
                                <label for="selectedAges">Start Date</label>
                                <p-calendar placeholder="Select Start Date" dateFormat="dd-mm-yy" appendTo="body"
                                    [(ngModel)]="selectedStartDate" (onSelect)="onSelectStartDate($event)"
                                    [showIcon]="true"></p-calendar>
                            </div>
                            <div class="filterList">
                                <label for="selectedAges">End Date</label>
                                <p-calendar placeholder="Select End Date" dateFormat="dd-mm-yy" appendTo="body"
                                    [(ngModel)]="selectedEndDate" (onSelect)="onSelectEndDate($event)"
                                    [showIcon]="true"></p-calendar>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="mainBtn">
            <div class="footerBtn">
                <button class="canelBtn" pButton type="button" label="CLEAR FILTER"
                    (click)="clear(); mobilFilter = false"></button>
                <button class="applyBtn" pButton type="button" label="APPLY" (click)="mobilFilter = false"></button>
            </div>
        </div>

    </ng-template>

</p-dialog>